module.exports = __webpack_public_path__ + "media/base/trash-13575614.svg";